import { getHeaders, PURCHASER_API_BASE_URL } from "../Constants";
import { NotificationType } from "./Notifications";

export type WebhookEndpoint = {
    id: number;
    enabled: boolean;
    secret?: string;
    url: string;
    events: NotificationType[];
    createdAt: string;
    updatedAt: string;
    teamId: number;
};

export type CreateWebhookEndpointInput = {
    enabled?: boolean;
    url: string;
    events: NotificationType[];
};

export type UpdateWebhookEndpointInput = {
    enabled?: boolean;
    url?: string;
    events?: NotificationType[];
};

export default {
    getWebhookEndpoints: (): Promise<WebhookEndpoint[]> =>
        fetch(`${PURCHASER_API_BASE_URL}/webhook-endpoints`, {
            method: "GET",
            headers: getHeaders(),
        }).then(res => {
            if (!res.ok) {
                throw new Error("Error fetching webhook endpoints");
            }
            return res.json();
        }),
    createWebhookEndpoint: (input: CreateWebhookEndpointInput): Promise<WebhookEndpoint> =>
        fetch(`${PURCHASER_API_BASE_URL}/webhook-endpoints`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify(input),
        }).then(res => {
            if (!res.ok) {
                throw new Error("Error creating webhook endpoint");
            }
            return res.json();
        }),
    updateWebhookEndpoint: (id: number, input: UpdateWebhookEndpointInput): Promise<WebhookEndpoint> =>
        fetch(`${PURCHASER_API_BASE_URL}/webhook-endpoints/${id}`, {
            method: "PATCH",
            headers: getHeaders(),
            body: JSON.stringify(input),
        }).then(res => {
            if (!res.ok) {
                throw new Error("Error updating webhook endpoint");
            }
            return res.json();
        }),
    deleteWebhookEndpoint: (id: number): Promise<WebhookEndpoint> =>
        fetch(`${PURCHASER_API_BASE_URL}/webhook-endpoints/${id}`, {
            method: "DELETE",
            headers: getHeaders(),
            body: JSON.stringify({}),
        }).then(res => {
            if (!res.ok) {
                throw new Error("Error deleting webhook endpoint");
            }
            return res.json();
        }),
};
